import { Link } from "react-router-dom";
import { Reveal } from "@/components/motion";

export default function CtaBand({
  image,
  title,
  sub,
  primaryText = "Plan Your Journey",
  primaryTo = "/contact",
  secondaryText,
  secondaryTo,
}) {
  return (
    <section data-testid="cta-band" className="relative w-full overflow-hidden">
      <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover" loading="lazy" />
      <div className="absolute inset-0 bg-black/55" />
      <div className="relative z-10 mx-auto max-w-[1600px] px-6 py-32 text-center lg:px-12 lg:py-44">
        <Reveal>
          <h2 className="mx-auto max-w-3xl font-serif text-4xl font-light leading-[1.02] tracking-tight text-white sm:text-5xl lg:text-6xl">
            {title}
          </h2>
        </Reveal>
        {sub && (
          <Reveal delay={0.12}>
            <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-white/80">{sub}</p>
          </Reveal>
        )}
        <Reveal delay={0.22}>
          <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Link to={primaryTo} data-testid="cta-band-primary" className="btn-outline-light !bg-white !text-ink hover:!bg-gold hover:!text-white hover:!border-gold">
              {primaryText}
            </Link>
            {secondaryText && secondaryTo && (
              <Link to={secondaryTo} data-testid="cta-band-secondary" className="btn-outline-light">
                {secondaryText}
              </Link>
            )}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
